import 'whatwg-fetch';
import config from '../../config/config';

const {
    API_MOBILE_AUTH_OTP_URL,
    API_MOBILE_AUTH_LOGIN_URL,
    API_MOBILE_SIGNUP,
    API_CURRENT_USER_URL,
} = config;

const appCode = process.env.REACT_APP_APP_CODE || 'EFEED MARKETPLACE';

export const authApi = {
    /**
     * Шаг 1: Запрос OTP-кода на телефон
     * POST FormData -> /wp-json/app/v1/mobile-auth-get/
     * Ответ: { code: 200, data: { id_session, otp_get_timeout, otp_wait_timeout } }
     */
    requestOtp: async ({ phone, lang = 'ru' }) => {
        const formData = new FormData();
        formData.append('lang', lang);
        formData.append('app_code', appCode);
        formData.append('phone', phone);

        const response = await fetch(API_MOBILE_AUTH_OTP_URL, {
            method: 'POST',
            body: formData,
            credentials: 'include',
        });

        const result = await response.json();

        if ((result.code && result.code !== 200) || (result.status && result.status !== 200)) {
            throw new Error(result.message || `Ошибка сервера: ${result.code || result.status}`);
        }

        if (!response.ok) {
            throw new Error(result.message || `HTTP ${response.status}`);
        }

        return result;
    },

    /**
     * Шаг 2: Подтверждение OTP-кода и авторизация
     * POST FormData -> /wp-json/app/v1/mobile-auth-put/
     * Ответ: { token, user_name, user_display_name, device_id }
     */
    confirmOtp: async ({ phone, idSession, otpCode, lang = 'ru' }) => {
        const formData = new FormData();
        formData.append('lang', lang);
        formData.append('app_code', appCode);
        formData.append('phone', phone);
        formData.append('id_session', idSession);
        formData.append('otp_code', otpCode);

        const response = await fetch(API_MOBILE_AUTH_LOGIN_URL, {
            method: 'POST',
            body: formData,
            credentials: 'include',
        });

        const result = await response.json();

        if (!result.token) {
            throw new Error(result.message || 'Неверный код подтверждения');
        }

        return result;
    },

    /**
     * Регистрация по телефону
     * POST FormData -> /wp-json/app/v1/signup/
     * Ответ: { token, user_name, user_display_name }
     */
    signup: async ({ phone, email, password, displayName, firstName, lastName, lang = 'ru' }) => {
        const formData = new FormData();
        formData.append('lang', lang);
        formData.append('app_code', appCode);
        formData.append('user_phone', phone);
        formData.append('user_email', email);
        formData.append('user_pass', password);
        if (displayName) formData.append('display_name', displayName);
        if (firstName) formData.append('first_name', firstName);
        if (lastName) formData.append('last_name', lastName);

        const response = await fetch(API_MOBILE_SIGNUP, {
            method: 'POST',
            body: formData,
            credentials: 'include',
        });

        const result = await response.json();

        if (!result.token && ((result.code && result.code !== 200) || (result.status && result.status !== 200))) {
            throw new Error(result.message || `Ошибка сервера: ${result.code || result.status}`);
        }

        if (!response.ok && !result.token) {
            throw new Error(result.message || `HTTP ${response.status}`);
        }

        return result;
    },

    /**
     * Получение данных текущего пользователя
     * GET /wp-json/app/expo/userdata
     */
    fetchUser: async (token) => {
        const response = await fetch(API_CURRENT_USER_URL, {
            headers: { Authorization: 'Bearer ' + token },
            credentials: 'include',
        });

        const result = await response.json();

        if (!response.ok) {
            throw new Error(result.message || `HTTP ${response.status}`);
        }

        return result;
    },
};
